<template>
	<div class="progress-input-invite">
		<div class="box" @click="clickLinkInvite">
			<img src="@/assets/svg/invite-member.svg" />
			<div class="txtbox">
				<p>링크로 초대하기</p>
				<span>링크를 공유하여 연구원들을 초대하세요</span>
			</div>
		</div>
		<div class="box" @click="clickEmailInvite">
			<img src="@/assets/svg/invite-email.svg" />
			<div class="txtbox">
				<p>이메일로 초대하기</p>
				<span>초대할 연구원들에게 메일을 보내세요.</span>
			</div>
		</div>
		<progress-input-email-invite
			v-if="isEmailInvite"
			@close="hideInvite"
			@submit="submit"
		></progress-input-email-invite>
	</div>
</template>

<script>
import instituteMemberAPI from '@/services/api/institute/member'
import ProgressInputEmailInvite from '@/views/create/components/ProgressInputEmailInvite.vue'
import { shareOrCopy } from '@/utils/modules/WebBridge'
export default {
	name: 'ProgressInputInvite',
	components: {
		ProgressInputEmailInvite,
	},
	props: {
		instituteId: {
			type: String,
			default: '',
		},
		groupId: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			isEmailInvite: false,
			groupsId: [],
		}
	},
	computed: {},
	methods: {
		clickEmailInvite() {
			this.isEmailInvite = true
		},
		hideInvite() {
			this.isEmailInvite = false
		},
		async submit(list) {
			this.groupsId.push(this.groupId)
			await instituteMemberAPI.sendInviteEmail(this.instituteId, {
				emails: list,
				groupsId: this.groupsId,
			})
		},
		async clickLinkInvite() {
			this.groupsId.push(this.groupId)
			const response = await instituteMemberAPI.createInviteLink(
				this.instituteId,
				{
					groupsId: this.groupsId,
				}
			)
			const result = await shareOrCopy(response.data.link)
			if (result === 'copied') {
				this.$notify({
					type: 'common',
					text: this.tt('링크가 복사되었습니다.'),
				})
			}
		},
	},
}
</script>

<style lang="scss" scoped>
.progress-input-invite {
	.box {
		width: 100%;
		background-color: #fff;
		border: 1px solid #eee;
		border-radius: 1rem;
		padding: 1rem;
		display: flex;
		align-items: center;
		height: auto;
		margin-bottom: 10px;
		img {
			width: 48px;
			height: 48px;
			margin-right: 10px;
		}
		.txtbox {
			width: calc(100% - 58px);
			height: 48px;
			background-image: url(~@/assets/svg/arrow-right_b.svg);
			background-repeat: no-repeat;
			background-position: center right 0;
			background-size: 16px;
			p {
				font-size: 1rem;
				font-weight: 600;
				margin-bottom: 4px;
			}
			span {
				display: block;
				font-size: 0.75rem;
				color: rgba(0, 0, 0, 0.6);
			}
		}
	}
}
</style>
